const continentToCountryCodes: Record<string, string[]> = {
  AF: [
    "DZ", "AO", "BJ", "BW", "BF", "BI", "CV", "CM", "CF", "TD", "KM", "CD", "CG", "CI", "DJ", "EG", "GQ", "ER",
    "SZ", "ET", "GA", "GM", "GH", "GN", "GW", "KE", "LS", "LR", "LY", "MG", "MW", "ML", "MR", "MU", "YT", "MA",
    "MZ", "NA", "NE", "NG", "RE", "RW", "SH", "ST", "SN", "SC", "SL", "SO", "ZA", "SS", "SD", "TZ", "TG", "TN",
    "UG", "EH", "ZM", "ZW",
  ],
  AN: ["AQ", "BV", "TF", "HM", "GS"],
  AS: [
    "AE", "AF", "AM", "AZ", "BH", "BD", "BT", "BN", "KH", "CN", "CX", "CC", "GE", "HK", "IN", "ID", "IR", "IQ",
    "IL", "JP", "JO", "KZ", "KW", "KG", "LA", "LB", "MO", "MY", "MV", "MN", "MM", "NP", "KP", "OM", "PK", "PS",
    "PH", "QA", "SA", "SG", "KR", "LK", "SY", "TW", "TJ", "TH", "TL", "TR", "TM", "UZ", "VN", "YE",
  ],
  EU: [
    "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ", "DK", "EE", "FO", "FI", "FR", "DE", "GI", "GR",
    "GG", "VA", "HU", "IS", "IE", "IM", "IT", "JE", "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL",
    "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI", "ES", "SJ", "SE", "CH", "UA", "GB",
  ],
  NA: [
    "AI", "AG", "AW", "BS", "BB", "BZ", "BM", "BQ", "VG", "CA", "KY", "CR", "CU", "CW", "DM", "DO", "SV", "GL",
    "GD", "GP", "GT", "HT", "HN", "JM", "MQ", "MX", "MS", "NI", "PA", "PR", "BL", "KN", "LC", "MF", "PM", "VC",
    "SX", "TT", "TC", "VI", "US",
  ],
  OC: [
    "AS", "AU", "CK", "FJ", "PF", "GU", "KI", "MH", "FM", "NR", "NC", "NZ", "NU", "NF", "MP", "PW", "PG", "PN",
    "WS", "SB", "TK", "TO", "TV", "UM", "VU", "WF",
  ],
  SA: ["AR", "BO", "BR", "CL", "CO", "EC", "FK", "GF", "GY", "PY", "PE", "SR", "UY", "VE"],
};

const countryToContinentCode: Record<string, string> = Object.entries(continentToCountryCodes).reduce(
  (accumulator, [continentCode, countryCodes]) => {
    countryCodes.forEach((countryCode) => {
      accumulator[countryCode] = continentCode;
    });

    return accumulator;
  },
  {} as Record<string, string>
);

function normalizeCountryCode(countryCode?: string | null): string | undefined {
  if (!countryCode) {
    return undefined;
  }

  const normalized = countryCode.toUpperCase();

  if (!/^[A-Z]{2}$/u.test(normalized)) {
    return undefined;
  }

  return normalized;
}

function normalizeContinentCode(continentCode?: string | null): string | undefined {
  if (!continentCode) {
    return undefined;
  }

  const normalized = continentCode.toUpperCase();

  if (!Object.prototype.hasOwnProperty.call(continentToCountryCodes, normalized)) {
    return undefined;
  }

  return normalized;
}

function getContinentCodeByCountryCode(countryCode?: string | null): string | undefined {
  const normalizedCountryCode = normalizeCountryCode(countryCode);

  if (!normalizedCountryCode) {
    return undefined;
  }

  return countryToContinentCode[normalizedCountryCode];
}

function getCountryCodesByContinentCode(continentCode?: string | null): string[] {
  const normalizedContinentCode = normalizeContinentCode(continentCode);

  if (!normalizedContinentCode) {
    return [];
  }

  return continentToCountryCodes[normalizedContinentCode] || [];
}

function getAllCountryCodes(): string[] {
  const allCodes = Object.values(continentToCountryCodes).flat();

  return Array.from(new Set(allCodes)).sort();
}

export {
  continentToCountryCodes,
  normalizeCountryCode,
  normalizeContinentCode,
  getContinentCodeByCountryCode,
  getCountryCodesByContinentCode,
  getAllCountryCodes,
};
